var PES = PES || {};
PES.RevealAnimation = function () {
    let controller = new ScrollMagic.Controller();

    function showElements(elem) {
        let timeline = new TimelineMax();
        let fadeIn = TweenMax.from(elem, 1.5, { opacity: 0, y: 50, ease: Power2.easeOut });
        timeline.add(fadeIn);

        let scene = new ScrollMagic.Scene({
            triggerElement: elem,
            offset: 0,
            triggerHook: 0.95,
            reverse: false
        })
        .setTween(timeline)
        .addTo(controller);
    }

	var init = function () {
        // reveal animation for homepage elements
        let revealElements = $('.toreveal');
        $(revealElements).each(function () {
            showElements(this);
        });
	};

	return {
		init: init
	};
};